import { CLIENT_ROUTES } from "config/paths";
import { generatePath } from "react-router-dom";

export const clientListingPath = (clientType, params) => {
  return generatePath(getRoutePath(clientType, "list"), params);
}

/**
 * Helper for get route for different client types
 */
export const getRoutePath = (clientType, actionType) => {
  if (CLIENT_ROUTES[clientType] && CLIENT_ROUTES[clientType][actionType]) {
    return CLIENT_ROUTES[clientType][actionType];
  }
  throw new Error(`Route not found for clientType: ${clientType} and actionType: ${actionType}`);
};